import { useEffect, useState } from "react";
import SpotlightCard from "@/components/SpotlightCard";
import { PERK_ICONS, PERKS_FALLBACK } from "../nova-data";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { ACTIVE_URL } from "@/constants";

type PerkText = { stat: string; label: string; description: string };

export function NovaPerks() {
  const { ref: headerRef, visible: headerVisible } = useScrollReveal(0.1);
  const { ref: cardsRef, visible: cardsVisible } = useScrollReveal(0.1);
  const [perks, setPerks] = useState<PerkText[]>(PERKS_FALLBACK);

  useEffect(() => {
    let cancelled = false;
    fetch(`${ACTIVE_URL}/api/nova-perks/`)
      .then(r => r.ok ? r.json() : null)
      .then((data: PerkText[] | null) => {
        if (!cancelled && Array.isArray(data) && data.length > 0) setPerks(data);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <section id="perks" className="max-w-[1200px] mx-auto px-6 pb-20">
      <div
        ref={headerRef}
        className="text-center mb-12 transition-all duration-700"
        style={{
          opacity: headerVisible ? 1 : 0,
          transform: headerVisible ? 'translateY(0)' : 'translateY(32px)',
        }}
      >
        <h2 className="text-4xl font-bold text-white mb-3 font-roboto">Τι κερδίζεις;</h2>
        <p className="text-white/50 text-lg">Όλα τα αποκλειστικά οφέλη για τους συνδρομητές Nova.</p>
      </div>
      <div ref={cardsRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-stretch">
        {perks.map((perk, i) => (
          <div
            key={i}
            className="transition-all duration-700 h-full"
            style={{
              opacity: cardsVisible ? 1 : 0,
              transform: cardsVisible ? 'translateY(0)' : 'translateY(40px)',
              transitionDelay: `${i * 100}ms`,
            }}
          >
            <SpotlightCard
              className="p-6 hover:scale-[1.02] transition-transform duration-200 h-full"
              spotlightColor="rgba(0, 217, 218, 0.15)"
            >
              <div className="mb-4">
                <svg className="w-8 h-8 text-[#00d9d9]" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d={PERK_ICONS[i] ?? PERK_ICONS[PERK_ICONS.length - 1]} />
                </svg>
              </div>
              <div className="text-3xl font-bold text-[#00d9d9] mb-1">{perk.stat}</div>
              <div className="text-white font-semibold text-sm mb-3">{perk.label}</div>
              <p className="text-white/50 text-sm leading-relaxed">{perk.description}</p>
            </SpotlightCard>
          </div>
        ))}
      </div>
    </section>
  );
}
